import { useMemo } from "react";
import { useCourseRoutable } from "@tecnobit-srl/courses-routable-types-course/lazy";
//#region src/index.ts
var useCoursesRoutableTypes = () => {
	const courseRoutable = useCourseRoutable();
	return useMemo(() => ({ ...courseRoutable }), [courseRoutable]);
};
//#endregion
export { useCoursesRoutableTypes };
